import { EAlertActionTypes, IAlertPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Показать алерт
 */
export const showAlert = actionGenerator<EAlertActionTypes.Show, IAlertPayload | void>(EAlertActionTypes.Show);
export const hideAlert = actionGenerator<EAlertActionTypes.Hide>(EAlertActionTypes.Hide);
